import "react-multi-carousel/lib/styles.css";
import { RouterProvider } from "react-router-dom";
import "./App.scss";
import routers from "./Router";
import { ThemeProvider } from "@mui/material/styles";
import theme from "Explore/Components/Common/theme";
// Global Helmet removed. Page-specific Helmet components handle metadata.

function App() {
  return (
    <ThemeProvider theme={theme}>
      {/* <CssBaseline /> */}
      <div className="App">
        <RouterProvider router={routers} />
      </div>
    </ThemeProvider>
  );
}

export default App;
